import { ChevronDown } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import Link from '../Link';
import { useShell } from './ShellContext';

/** The address is the navigation: the host goes home, and the path opens the list of tools. */
export default function PathControl() {
  const { pathname } = useLocation();
  const { openTools } = useShell();
  const path = pathname.replace(/^\/+|\/+$/g, '');

  return (
    <div className="flex min-w-0 items-center font-mono text-sm font-medium">
      <Link
        to="/"
        className="flex h-11 shrink-0 items-center rounded-md pl-1 pr-0.5 text-white/70 no-underline hover:text-white hover:no-underline"
        style={{ textDecoration: 'none' }}
      >
        saarim.app{path ? '/' : ''}
      </Link>
      <button
        type="button"
        onClick={openTools}
        aria-label={path ? `Current page ${path}. Open tools` : 'Open tools'}
        title="Open tools"
        className="flex h-11 min-w-0 items-center gap-1 rounded-md pr-1.5 text-white hover:bg-white/5 [@media(pointer:coarse)]:min-w-11 [@media(pointer:coarse)]:justify-center"
      >
        {path ? <span className="truncate">{path}</span> : null}
        <ChevronDown aria-hidden className="size-3.5 shrink-0 text-white/60" />
      </button>
    </div>
  );
}
